import script from "./BulkDeleteAnnotationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkDeleteAnnotationModal.vue?vue&type=script&setup=true&lang=js"

import "./BulkDeleteAnnotationModal.vue?vue&type=style&index=0&id=6de0b153&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6de0b153"]])

export default __exports__